import { render, staticRenderFns } from "./DeletePersonalNotification.vue?vue&type=template&id=fc26a1c0&scoped=true&"
import script from "./DeletePersonalNotification.vue?vue&type=script&lang=js&"
export * from "./DeletePersonalNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc26a1c0",
  null
  
)

export default component.exports